import React                from "react";
import PropTypes            from "prop-types";
import Store                from "Dashboard/Core/Store";
import useForm              from "Dashboard/Hooks/Form";
import useDialog            from "Dashboard/Hooks/Dialog";

// Dashboard
import EditDialog           from "Dashboard/Components/Dialogs/EditDialog";
import InputField           from "Dashboard/Components/Form/InputField";



/**
 * The Category Edit Dialog
 * @param {Object} props
 * @returns {React.ReactElement}
 */
function CategoryEdit(props) {
    const { open, elemID, onClose, onSubmit } = props;

    const { statuses } = Store.useState("contactCategory");
    const { editElem } = Store.useAction("contactCategory");


    // The Initial Data
    const initialData = {
        contactCategoryID : 0,
        name              : "",
        status            : "Active",
        position          : 0,
    };

    // The Form State
    const {
        data, errors, setElem, handleChange, handleSubmit,
    } = useForm("contactCategory", initialData, editElem, onSubmit);

    // Load the Data
    const { loading } = useDialog("contactCategory", open, elemID, {}, setElem);


    // Do the Render
    return <EditDialog
        open={open}
        icon="category"
        title={elemID ? "CATEGORIES_EDIT_TITLE" : "CATEGORIES_CREATE_TITLE"}
        error={errors.form}
        onSubmit={handleSubmit}
        onClose={onClose}
        isLoading={loading}
        isNarrow
    >
        <InputField
            name="name"
            label="GENERAL_NAME"
            value={data.name}
            error={errors.name}
            onChange={handleChange}
            isRequired
        />
        <InputField
            type="select"
            name="status"
            label="GENERAL_STATUS"
            options={statuses}
            value={data.status}
            error={errors.status}
            onChange={handleChange}
            hideClear
            isRequired
        />
        <InputField
            type="number"
            name="position"
            label="GENERAL_POSITION"
            value={data.position}
            error={errors.position}
            onChange={handleChange}
            minValue={0}
        />
    </EditDialog>;
}

/**
 * The Property Types
 * @typedef {Object} propTypes
 */
CategoryEdit.propTypes = {
    open     : PropTypes.bool.isRequired,
    onClose  : PropTypes.func.isRequired,
    onSubmit : PropTypes.func.isRequired,
    elemID   : PropTypes.number,
};

export default CategoryEdit;
